import React, { useEffect, useState } from 'react';

import { EYE_STATUS_OPTIONS, MOUTH_STATUS_OPTIONS } from '@vlabs/api-bindings/src/constants';
import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { estimateFaceAttributesBySampleId } from '@vlabs/shared/requests';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './tabs.module.sass';

const AdditionalPropertiesTab = ({ sampleId }) => {
  const { t } = useTranslation();
  const [faceAttributes, setFaceAttributes] = useState();

  useEffect(() => {
    const fetchAttributes = async () => {
      const data = await estimateFaceAttributesBySampleId(sampleId);
      setFaceAttributes({ ...data?.attributes, ...data?.quality });
    };

    if (sampleId) {
      fetchAttributes();
    }
  }, [sampleId]);

  let mouthComponent = null;
  let eyesComponent = null;

  if (faceAttributes?.mouth_attributes && Object.keys(faceAttributes.mouth_attributes).length !== 0) {
    const { score, ...attribute } = faceAttributes.mouth_attributes;

    const maxAttribute = Object.entries(attribute).sort((attr1, attr2) => attr2[1] - attr1[1])[0];
    mouthComponent = <div>{`${MOUTH_STATUS_OPTIONS[maxAttribute[0]].label} (${maxAttribute[1]})`}</div>;
  }

  if (faceAttributes?.eyes_attributes) {
    eyesComponent = (
      <div className={st.AttributesWrapper}>
        <div className={st.AttributesWrapper_margin}>
          {`${t('left')} (${EYE_STATUS_OPTIONS[faceAttributes.eyes_attributes.left_eye?.state]?.label})`}
        </div>
        <div>{`${t('right')} (${EYE_STATUS_OPTIONS[faceAttributes.eyes_attributes.right_eye?.state]?.label})`}</div>
      </div>
    );
  }

  return (
    <div className={st.AdditionalPropertiesTab}>
      <InfoRow title={t('head_tilt_roll')} value={faceAttributes?.head_pose?.roll} />
      <InfoRow title={t('head_tilt_pitch')} value={faceAttributes?.head_pose?.pitch} />
      <InfoRow title={t('head_rotation_yaw')} value={faceAttributes?.head_pose?.yaw} />
      <InfoRow title={t('gaze_direction_pitch')} value={faceAttributes?.gaze?.pitch} />
      <InfoRow title={t('gaze_direction_yaw')} value={faceAttributes?.gaze?.yaw} />
      <InfoRow title={t('light_quality')} value={faceAttributes?.light} />
      <InfoRow title={t('dark_quality')} value={faceAttributes?.dark} />
      <InfoRow title={t('blur_quality')} value={faceAttributes?.blurriness} />
      <InfoRow title={t('specularity')} value={faceAttributes?.specularity} />
      <InfoRow title={t('illumination_quality')} value={faceAttributes?.illumination} />
      <InfoRow title={t('mouth_state')} value={mouthComponent} />
      <InfoRow title={t('eye_state')} value={eyesComponent} />
    </div>
  );
};

AdditionalPropertiesTab.propTypes = {
  sampleId: PropTypes.string.isRequired,
};

export { AdditionalPropertiesTab };
